export default class Sizes {
  ratio = 1.0;
  //ammount of lines at the board
  linesCount = 28;
  //ammount of lines in column
  xLinesCount = 14;
  //ammount of lines in row
  yLinesCount = 3;
  checkerScale = 1;
  doubleCubeWidthScaleCoeff = 20; //times that DoubleCubeView smaller than board
  lineScaleCoeff = 1.12;

  checkerSize = {
    width: 0,
    height: 0,
  };

  lineSize = {
    width: 0,
    height: 0,
  };

  canvasSize = {
    width: 0,
    height: 0,
  };

  twoDicesSize = {
    width: 0,
    height: 0,
  };

  diceSize = {
    width: 0,
    height: 0,
  };

  pointSize = {
    width: 0,
    height: 0,
  };

  holeSize = {
    width: 0,
    height: 0,
  };

  doubleCubeSize = {
    width: 0,
    height: 0,
  };

  recalculate() {
    // this.updateConstants();

    this.lineSize.width = (this.canvasSize.width / (this.xLinesCount + 3)) * this.lineScaleCoeff;
    this.lineSize.height = (this.canvasSize.height / this.yLinesCount) * this.lineScaleCoeff;
    this.checkerSize.width = this.lineSize.width * this.checkerScale;
    this.checkerSize.height = this.checkerSize.width;

    this.pointSize.width = this.diceSize.width / 5.5;
    this.pointSize.height = this.pointSize.width;

    this.doubleCubeSize.width = this.canvasSize.width / this.doubleCubeWidthScaleCoeff;
    this.doubleCubeSize.height = this.doubleCubeSize.width;
  }

  getLineSize() {
    return this.lineSize;
  }

  getCheckerSize() {
    return this.checkerSize;
  }

  getCanvasSize() {
    return this.canvasSize;
  }

  getDiceSize() {
    return this.diceSize;
  }

  getTwoDicesSize() {
    return this.twoDicesSize;
  }

  getPointSize() {
    return this.pointSize;
  }

  getHoleSize() {
    return this.holeSize;
  }

  getDoubleCubeSize() {
    return this.doubleCubeSize;
  }

  setCanvasSize(width: number, height: number, ratio: number) {
    this.canvasSize.width = width;
    this.canvasSize.height = height;
    this.ratio = ratio;
    this.recalculate();
  }

  setCanvasWidth(width: number) {
    this.canvasSize.width = width;
  }

  setCanvasHeight(height: number) {
    this.canvasSize.height = height;
  }
}
